import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators.js';
import {connect} from 'pwa-helpers';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import {classMap} from 'lit/directives/class-map.js';
import store from '../../store';
import style from '../../../../scss/imageZoom.scss';
import close from '../../icons/close';

@customElement('arc-image-zoom')
export class ImageZoom extends connect(store)(LitElement) {
	static styles = [style];
	static properties = {
		open: {type: Boolean},
		file: {type: Object}
	};

	constructor() {
		super();
		this.open = false;
		this.file = null;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
	}
	firstUpdated(changedProps) {
		this.dialog = this.renderRoot.querySelector('dialog');
		this.img = this.renderRoot.querySelector('img');
		// listen to external commands
		document.addEventListener('image-zoom', this.openImageZoom.bind(this));
		document.addEventListener('close-dialog', this.closeImageZoom.bind(this));
		// do something when closed
		this.dialog.addEventListener('close', this.handleClose.bind(this));
	}

	openImageZoom(e) {
		console.log('openImageZoom', e.detail);
		this.file = e.detail.file;

		// add js-fixScoll class to html element
		document.documentElement.classList.add('js-fixScroll');

		this.open = true;
		this.dialog.showModal();
	}
	closeImageZoom() {
		this.open = false;
		this.dialog.close();
	}

	handleClick(e) {
		if (this.open) this.dialog.close();
	}
	handleClose(e) {
		this.file = null;
		document.documentElement.classList.remove('js-fixScroll');
	}


	render() {
		const srcset = this.file?.thumbs.map((thumb) => thumb.url+' '+thumb.w+'w').join(', ');

		return html`
			<dialog class="zoomImage" @click=${this.handleClick}>
				<div class="modal-content">
					${when( this.file?.thumbs?.length > 0, () => html`
					<img
						class="img"
						src="${this.file.thumbs[0].url}"
						srcset="${srcset}"
						alt="${this.alt}" />
					`)}
					<button class="closeIcon" @click=${() => this.dialog.close('cancel')} aria-label="${msg('Close')}">
						${close}
					</button>
				</div>
			</dialog>
		`;
	}
}
